import { render, staticRenderFns } from "./search-field.vue?vue&type=template&id=4438d541"
import script from "./search-field.vue?vue&type=script&lang=js"
export * from "./search-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports